import qrcode from 'qrcode-generator';

export default class QrCodeGenerator {
    constructor() {
        this.handlers = document.querySelectorAll(".qr-code");
        if (this.handlers.length === 0)
            return;
        this.addEventListeners();
    }

    addEventListeners() {
        $(this.handlers).on('click', this.handleClick.bind(this));
    }

    handleClick(evt) {
        const qrCodeContainer = $(evt.currentTarget);
        const qrCodeImage = $('.qr-code-image', qrCodeContainer);
        const clickForQrText = $('.click-for-qr-text', qrCodeContainer);

        const textIsActive = !clickForQrText.hasClass("d-none") && qrCodeImage.hasClass("d-none");
        const qrCodeImageActive = !qrCodeImage.hasClass("d-none") && clickForQrText.hasClass("d-none");

        if (textIsActive) {
            const qrValue = qrCodeContainer.data('ticket');
            this.generateQrCode(qrCodeImage, qrValue);
            qrCodeImage.fadeIn(500);
            qrCodeImage.removeClass('d-none');
            clickForQrText.fadeOut(500);
            clickForQrText.addClass('d-none');
        } else if (qrCodeImageActive) {
            clickForQrText.fadeIn(500);
            clickForQrText.removeClass('d-none');
            qrCodeImage.fadeOut(500);
            qrCodeImage.addClass('d-none');
        }
    }

    generateQrCode(element, qrValue) {
        const typeNumber = 4;
        const errorCorrection = 'L';
        const qr = qrcode(typeNumber, errorCorrection);
        qr.addData(qrValue);
        qr.make();
        $(element).find("img").remove(); // Remove the img element inside .qr-code-image
        $(element).prepend(qr.createImgTag(10, 0)); // Append the new QR code image
    }
}